document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".addon-checkbox");
  if (!wrapper) return;

  const checkbox = wrapper.querySelector("input");
  const variantId = wrapper.dataset.variantId;

  checkbox.addEventListener("change", () => {
    if (checkbox.checked) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
    } else {
      fetch("/cart.js")
        .then(res => res.json())
        .then(cart => {
          const item = cart.items.find(i => i.variant_id == variantId);
          if (!item) return;

          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 0 })
          });
        });
    }
  });
});
